import {computed} from '@api'
import {VipLocalStore} from '@modules'
import {IGroupByPage, IGroupByPageRow, IGroupsPerPage, GroupByPageTitleStore} from '@modules/pdf'
import {StoresInstance} from '@stores'

export class GroupByPageIndividualStore extends VipLocalStore {
  constructor(stores: StoresInstance, public props?: IGroupsPerPage) {super(stores)}

  get grouping() {
    const {pdf: {grouping}} = this
    return grouping
  }

  get data() {
    const {props} = this
    return props.data
  }

  get group() {
    const {props} = this
    return props.group
  }

  get pageIndex() {
    const {props} = this
    return props.pageIndex
  }

  @computed get columns() {
    const {} = this

    return []
  }

  @computed get page(): IGroupByPage {
    const {rows, columns, pageIndex, grouping: {groupName}} = this
    return {pageIndex, rows, groupName, columns}
  }

  @computed get rows(): Array<IGroupByPageRow> {
    const {data, catalog, group} = this
    return data.map((items, index) => {
      const {total: count, spec} = new GroupByPageTitleStore(catalog.stores, {group: group[index]})

      return {spec, count, items}
    })
  }

}


// WEBPACK FOOTER //
// ./src/modules/pdf/templates/vlp/GroupByPageIndividualStore.ts